import React, { useEffect, useState } from "react";
import { useError } from "../../../contexts/ErrorContext";
import useApi from "../../../hooks/useGaneshApi";

import {
  GridColDef,
  GridInitialState,
  GridRenderCellParams,
} from "@mui/x-data-grid-premium";
import { Link } from "react-router-dom";
import { BrandChildren_T } from "../../../types/Brand";

import GaneshDataGrid from "../../DataGrid/GaneshDataGrid";

interface ChildrenBrandsbyBrandTableProps {
  brand_id: string;
  custom_height?: string;
}

const defaultGridState: GridInitialState = {
  filter: {
    filterModel: {
      items: [],
    },
  },
  sorting: { sortModel: [{ field: "child_brand_id", sort: "asc" }] },
  pagination: { paginationModel: { pageSize: 25, page: 0 } },
  pinnedColumns: { left: [] },
  columns: { columnVisibilityModel: {} },
  density: "compact",
};

const columns_def: GridColDef[] = [
  {
    field: "child_brand_id",
    headerName: "Child Brand Id",
    description: "Brand with a Child relationship with the brand of interest",
    type: "string",
    width: 100,
  },
  {
    field: "child_brand_name",
    headerName: "Child Brand Name",
    description: "Name of the brand with child relationship",
    type: "string",
    width: 300,
    renderCell: (params: GridRenderCellParams) => (
      <Link to={`/data-ops/brand/${params.row.child_brand_id}`}>
        {params.value}
      </Link>
    ),
  },
  {
    field: "parent_brand_id",
    headerName: "Parent Brand Id",
    description: "Brand id of the parent brand",
    type: "string",
    width: 100,
  },
];

const ChildrenBrandsbyBrandTable: React.FC<ChildrenBrandsbyBrandTableProps> = ({
  brand_id,
  custom_height,
}) => {
  const [childrenBrandsbyBrandData, setChildrenBrandsbyBrandData] = useState<
    BrandChildren_T[]
  >([]);
  const [loading, setLoading] = useState(true);

  const { showError } = useError();
  const { apiRequest } = useApi();

  useEffect(() => {
    if (brand_id) {
      const fetchChildrenBrandsbyBrandData = async () => {
        try {
          const response = await apiRequest<BrandChildren_T[]>(
            `/brand_reports/children_brands/${brand_id}`,
            {
              method: "GET",
            }
          );
          if (response.data) {
            setChildrenBrandsbyBrandData(response.data);
          }
        } catch (error) {
          console.error(error);
          showError(`Failed to fetch children brand for ${brand_id}.`);
        } finally {
          setLoading(false);
        }
      };
      fetchChildrenBrandsbyBrandData();
    }
  }, [brand_id]);

  return (
    <GaneshDataGrid
      loading={loading}
      data={childrenBrandsbyBrandData}
      columns={columns_def}
      gridId="ChildrenBrandsbyBrandGrid"
      defaultGridState={defaultGridState}
      customHeight={custom_height}
    />
  );
};

export default ChildrenBrandsbyBrandTable;
